module.exports = __webpack_public_path__ + "3a989e4c.svg";